import { faArrowToBottom } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@kcftech/design-system';
import { ILocationResponse, JobType } from '@kcftech/prometheustypescriptapiclient';
import { useUserDateTimeFormat } from 'custom_hooks/useUserDateTimeFormat';
import { jobTypeToName } from 'pages/Settings/SetupTools/shared';
import { fetchFileFromApi } from 'utils/fetch';
import { downloadFile, FileType } from 'utils/file';

export type SetupToolsTemplateDownloadButtonProps = Readonly<{
    location: ILocationResponse | undefined;
    filterId: string | undefined;
    jobType: JobType;
}>;

const getDownloadLinkForJobType = (
    jobType: string,
    locationId: string,
    filterId?: string
) =>
    `setupTools/${jobType}?locationId=${locationId}${
        filterId ? `&filterId=${filterId}` : ''
    }`;

export const getTemplateFileName = (
    locationName: string,
    jobType: JobType,
    formatDate: (date: Date) => string
) => `${locationName}_${jobTypeToName[jobType]}_${formatDate(new Date())}.xlsx`;

export function SetupToolsTemplateDownloadButton({
    location,
    filterId,
    jobType,
}: SetupToolsTemplateDownloadButtonProps) {
    const { formatDate } = useUserDateTimeFormat();

    const onTemplateDownload = async () => {
        if (!location) {
            throw new Error(
                'Attempted to download template file without a location selected'
            );
        }

        const file = await fetchFileFromApi(
            getDownloadLinkForJobType(jobType, location.Id, filterId),
            getTemplateFileName(location.Name, jobType, formatDate),
            FileType.Excel,
            {
                method: 'GET',
            }
        );
        downloadFile(file);
    };

    return (
        <Button
            className="mr-20"
            appearance="primary"
            spacing="medium"
            icon={<FontAwesomeIcon icon={faArrowToBottom} />}
            disabled={location === undefined}
            onClick={onTemplateDownload}
        >
            Download Template
        </Button>
    );
}
